import PropTypes from "prop-types";
import React from "react";
import {
  stringToTicketPhase,
  stringToTicketStatus,
  TicketPhase,
  TicketStatus,
} from "../../assets/js/AppTicketConstant";
import { Button } from "@nextui-org/button";

const DealerTicketActionButton = ({
  onCancelTicket,
  ticketPhase,
  ticketStatus,
}) => {
  return (
    <>
      <Button
        className="rounded-xl bg-black !text-white font-medium text-nowrap py-2 w-fit"
        isDisabled={
          stringToTicketPhase(ticketPhase) !== TicketPhase.Proposal ||
          stringToTicketStatus(ticketStatus) === TicketStatus.Cancelled
        }
        onPress={onCancelTicket}
      >
        ยกเลิกการส่งคำขอทั้งหมด
      </Button>
    </>
  );
};

DealerTicketActionButton.propTypes = {
  onCollapse: PropTypes.func,
  onPrint: PropTypes.func,
  onCancelTicket: PropTypes.func,
  ticketPhase: PropTypes.any,
  ticketStatus: PropTypes.any,
};

export default DealerTicketActionButton;
